// Template Generated by DataExtraction.py at 1714177343

import EnrolmentFormsEn3 from "../../Forms/Enrolment Forms/EnrolmentForms_En3.png";
import EnrolmentFormsEn3Labels from "../../Labels/Enrolment Forms/EnrolmentForms_En3.json";
import EnrolmentFormsFr3 from "../../Forms/Enrolment Forms/EnrolmentForms_Fr3.png";
import EnrolmentFormsFr3Labels from "../../Labels/Enrolment Forms/EnrolmentForms_Fr3.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY, formatDayFromDate, formatMonthFromDate, formatYearFromDate, getProvinceLongNameForShortName,
    signatureTab, signatureLabel, initialsTab
} from "../../PDFGenerationUtils";
import { PLAN_TYPE_IDS, POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";
import moment from "moment/moment";
import app from "../../../App";


/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n, state) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? EnrolmentFormsFr3Labels : EnrolmentFormsEn3Labels;
    const formImage = isFrench ? EnrolmentFormsFr3 : EnrolmentFormsEn3;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, true);
    }

    const application = data.application;
    const plan = data.plan;
    const common = data.common;

    const nowDate = moment(new Date()).format("YYYY-MM-DD");

    let currentYear = new Date().getFullYear();
    let thirtyOneYearsFromNow = currentYear + 31;
    let thirtyFiveYearsFromNow = currentYear + 35;

    thirtyOneYearsFromNow = thirtyOneYearsFromNow.toString();
    thirtyFiveYearsFromNow = thirtyFiveYearsFromNow.toString();

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */
    const agent = common.agentCode;


    /*//////////////////////////////// Test Placements

   drawText("1", "Initials1_s1_test");
    drawText("2", "Initials1_s2_test");
    drawText("3", "Initials1_s3_test");
//    drawText("4", "Initials1_s4_test");
    //drawText("5", "Initials1_s5_test");
    //drawText("6", "Initials1_s6_test");
    //drawText("7", "Initials1_s7_test");
   // drawText("8", "Initials1_s8_test");
    //drawText("9", "Initials1_s9_test");
    if (agent && agent.dualLicenseYN) {
        drawText("4", "Initials1_s4_test");
    }
    drawText("5", "Initials1_s5_test");
    if (plan.planTypeID == PLAN_TYPE_IDS.GROUP && common.signingProvince != "PQ" && plan.completionInsurance) {
        drawText("6", "Initials1_s6_test");
    }
    drawText("7", "Initials1_s7_test");
    if (plan.planTypeID == PLAN_TYPE_IDS.GROUP && common.signingProvince != "PQ" && !plan.completionInsurance) {
        drawText("9", "Initials1_s9_test");
    }
    if (!isFrench && common.signingProvince == "PQ") {
        drawText("8", "Initials1_s8_test");
    }
    if (common.subscriber2Include) {
        drawText("1", "Initials1_sa_test");
        drawText("2", "Initials1_sb_test");
        drawText("3", "Initials1_sc_test");
        if (agent && agent.dualLicenseYN) {
            drawText("4", "Initials1_sd_test");
        }
        drawText("5", "Initials1_se_test");
        if (plan.planTypeID == PLAN_TYPE_IDS.GROUP && common.signingProvince != "PQ" && plan.completionInsurance) {
            drawText("6", "Initials1_sf_test");
        }
        drawText("7", "Initials1_sg_test");
        if (plan.planTypeID == PLAN_TYPE_IDS.GROUP && common.signingProvince != "PQ" && !plan.completionInsurance) {
            drawText("9", "Initials1_si_test");
        }
        if (!isFrench && common.signingProvince == "PQ") {
            drawText("8", "Initials1_sh_test");
        }
    }*/
    //////////////////////////////////
    // Drawing the form
    // fillCheckbox(borrowingToInvestNo, "borrowingToInvestNo"); // unused
    // fillCheckbox(borrowingToInvestYes, "borrowingToInvestYes"); // unused

    fillCheckbox(application.cardType == "AMEX", "cardTypeAMEX");
    fillCheckbox(application.cardType == "Mastercard", "cardTypeMasterCard");
    fillCheckbox(application.cardType == "Visa", "cardTypeVisa");

    // drawText(existingPreauthorizedDeposits, "existingPreauthorizedDeposits"); // unused

    // fillCheckbox(insuranceCompletionN, "insuranceCompletionN"); // appears to be unused
    // fillCheckbox(insuranceCompletionS2, "insuranceCompletionS2"); // appears to be unused


/*    let insuranceJoint = common.subscriber2Include;
    if (!plan.completionInsurance && !insuranceJoint) {
        fillCheckbox(true, "insuranceCompletionS1");
    } else if (!plan.completionInsurance && insuranceJoint) {
        fillCheckbox(true, "insuranceCompletionJ");
    }*/

    drawText(formatDayFromDate(common.prospectusDate), "prospectusDateDay");
    drawText(formatMonthFromDate(common.prospectusDate), "prospectusDateMonth");
    drawText(formatYearFromDate(common.prospectusDate), "prospectusDateYear");
    drawText(common.agentCode, "repCode");
    drawText(common.agentName, "repName");
    drawText(getProvinceLongNameForShortName(common.signingProvince), "signingProvince");
    drawText(application.specialInstructions, "specialInstructions");
    // drawText(cardAmount, "cardAmount"); // unused

    drawText(nowDate, "subscriberSignDate");
    drawText(thirtyOneYearsFromNow, "year31FollowingEnrolment");
    drawText(thirtyFiveYearsFromNow, "year35FollowingEnrolment");

    // TODO need to add 2nd plan
    if (plan.ongoingDepositMethod == "PAP" || plan.initialDepositMethod == "PAP") {
        drawText(application.transit, "transit");
        drawText(application.bank, "bank");
        drawText(application.bankName, "bankName");
        drawText(application.accountNumber, "accountNumber");
    }

    // TODO need to add 2nd plan
    if (plan.ongoingDepositMethod == "Credit Card" || plan.initialDepositMethod == "Credit Card") {
        drawText(application.cardNumber, "cardNumber");
        drawText(application.cardCVV, "cardCVV");
        drawText(application.cardNumber, "cardNumber");
        drawText(application.expiryMonth, "expiryMonth");
        drawText(application.expiryYear, "expiryYear");

        drawText(formatDayFromDate(application.signingDate), "cardStartDateDay");
        drawText(formatMonthFromDate(application.signingDate), "cardStartDateMonth");
        drawText(formatYearFromDate(application.signingDate), "cardStartDateYear");
    }


}


//Returns the signature definitions for the document
// This includes who needs to sign and where
// The signature definition is a list of signers, each with a list of tabs
const signatureDefinitions = (state, documentId, pageNumber, i18n, authenticationStatus) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? EnrolmentFormsFr3Labels : EnrolmentFormsEn3Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];

    const tinyInitialsScale = 0.5;
    // Dealing Rep
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('dealingRepresentativeSignature', labels))],
    });

    //Primary subscriber
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('subscriber1Signature', labels))],
    });

    // initials 1
    signers.push({
        [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials1_s1', labels), tinyInitialsScale)],
    });


    // initials 2
    signers.push({
        [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials2_s1', labels), tinyInitialsScale)],
    });

    // initials 3
    signers.push({
        [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials3_s1', labels), tinyInitialsScale)],
    });

    const agent = authenticationStatus.user.agentCodes.find((ac) => ac.code === state.common.agentCode);


    if (authenticationStatus && authenticationStatus.user && agent && agent.dualLicenseYN) {
        // initials 4
        signers.push({
            [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials4_s1', labels), tinyInitialsScale)],
        });
    }

    // initials 5
    signers.push({
        [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials5_s1', labels), tinyInitialsScale)],
    });

    if (state.plan.planTypeID == PLAN_TYPE_IDS.GROUP && state.common.signingProvince != "PQ" && state.plan.completionInsurance) {
        // initials 6
        signers.push({
            [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials6_s1', labels), tinyInitialsScale)],
        });
    }
    // initials 7
    signers.push({
        [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials7_s1', labels), tinyInitialsScale)],
    });

    if (state.plan.planTypeID == PLAN_TYPE_IDS.GROUP && state.common.signingProvince != "PQ" && !state.plan.completionInsurance) {

        // initials insurance OptOut
        signers.push({
            [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('InitialsOptOut_s1', labels), tinyInitialsScale)],
        });
    }

    if (!isFrench && state.common.signingProvince == "PQ") {

        // initials 8 Doesn't exist in french
        signers.push({
            [subscriberRecipientId]: [initialsTab(subscriberRecipientId, documentId, pageNumber, signatureLabel('Initials8_s1', labels), tinyInitialsScale)],
        });
    }

    //Joint subscriber
    if (state.common.subscriber2Include) {
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('subscriber2Signature', labels))],
        });

        // initials 1
        signers.push({
            [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials1_s2', labels), tinyInitialsScale)],
        });

        // initials 2
        signers.push({
            [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials2_s2', labels), tinyInitialsScale)],
        });

        // initials 3
        signers.push({
            [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials3_s2', labels), tinyInitialsScale)],
        });

        if (authenticationStatus && authenticationStatus.user && agent && agent.dualLicenseYN) {
            // initials 4
            signers.push({
                [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials4_s2', labels), tinyInitialsScale)],
            });
        }

        // initials 5
        signers.push({
            [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials5_s2', labels), tinyInitialsScale)],
        });

        if (state.plan.planTypeID == PLAN_TYPE_IDS.GROUP && state.common.signingProvince != "PQ" && state.plan.completionInsurance) {
            // initials 6
            signers.push({
                [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials6_s2', labels), tinyInitialsScale)],
            });
        }

        // initials 7
        signers.push({
            [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials7_s2', labels), tinyInitialsScale)],
        });

        if (state.plan.planTypeID == PLAN_TYPE_IDS.GROUP && state.common.signingProvince != "PQ" && !state.plan.completionInsurance) {

            // initials insurance OptOut
            signers.push({
                [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('InitialsOptOut_s2', labels), tinyInitialsScale)],
            });
        }

        if (!isFrench && state.common.signingProvince == "PQ") {
            // initials 8 Doesn't exist in french
            signers.push({
                [jointSubscriberRecipientId]: [initialsTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel('Initials8_s2', labels), tinyInitialsScale)],
            });
        }
    }

    let hasCreditCard = state.plan.ongoingDepositMethod === "Credit Card" || state.plan.initialDepositMethod === "Credit Card" || state.plan2.ongoingDepositMethod === "Credit Card" || state.plan2.initialDepositMethod === "Credit Card"
    let hasPAP = state.plan.ongoingDepositMethod === "PAP" || state.plan.initialDepositMethod === "PAP" || state.plan2.ongoingDepositMethod === "PAP" || state.plan2.initialDepositMethod === "PAP"

    if (hasPAP) {
        // account holder
        const accountHolderRecipientId = state.application.papSubscriber == 1 ? subscriberRecipientId : jointSubscriberRecipientId;
        signers.push({
            [accountHolderRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('accountHolderSignature', labels))],
        });
    }

    if (hasCreditCard) {
        // credit card holder
        const creditCardRecipientId = state.application.creditSubscriber == 1 ? subscriberRecipientId : jointSubscriberRecipientId;
        signers.push({
            [creditCardRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('creditCardSignature', labels))],
        });
    }

    return signers;
}

export default {
    generate,
    signatureDefinitions
}
